import { Button, Card, Col, Modal, Row, Space } from "antd";
import { Form, Formik } from "formik";

import { Input } from "components/form";
import CompanyConfigMailTable from "components/table/CompanyConfigMailTable";
import { useTranslation } from "react-i18next";
import { initialValues } from "../schemas/companyConfigMailSchema";
import styles from "../styles/CompanyBranchFilter.module.css";
import ModalConfigMail from "components/elements/Modal/ModalConfigMail";


const CompanyConfigMailFilter = ({
  useFilter,
  onSearch = () => { },
  onEdit = () => { },
  onDelete = () => { },
  onView = () => { },
  onChange = () => { },
  onCancel = () => { },
  onTestConnent = () => { },
  onSubmit = () => { },
  isLoadingData = false,
  isLoading = false,
  pagination = {},
  configMailList = [],
  showModal,
  rowIndex,
  type,
  testConnect = true,
  commonTypeByGroupType = []
}) => {

  const { t } = useTranslation();
  return (
    <>
      {showModal &&
        <ModalConfigMail
          isLoading={isLoadingData}
          isModalOpen={showModal}
          title={type === "Add" ? t("companyConfigMail.addMail") : t("companyConfigMail.update")}
          type={type}
          values={rowIndex}
          handleCancel={onCancel}
          onTestConnent={onTestConnent}
          onSubmit={onSubmit}
          testConnect={testConnect}
          commonTypeByGroupType={commonTypeByGroupType}
        />}

      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          onSearch({
            ...values,
          });
        }}
      >
        {({ resetForm, values = {}, setFieldValue = () => { }, setTouched = () => { } }) => {
          return (
            <Form>
              {useFilter && (
                <Card>
                  <Row gutter={[24, 16]}>
                    <Col span={8}>
                      <Input
                        name="host"
                        label={t('companyConfigMail.hostName')}
                        placeholder={t('companyConfigMail.hostName')}
                        size="large"
                      />
                    </Col>
                    <Col span={8}>
                      <Input
                        name="port"
                        label={t('companyConfigMail.port')}
                        placeholder={t('companyConfigMail.port')}
                        size="large"
                      />
                    </Col>
                    <Col span={8}>
                      <Input
                        name="userName"
                        label={t('companyConfigMail.username')}
                        placeholder={t('companyConfigMail.username')}
                        size="large"
                      />
                    </Col>
                  </Row>
                  <Row justify="end">
                    <Space size={12} className={styles.filterbtn}>
                      <Button type="default" onClick={resetForm} style={{ height: "40px", borderRadius: "8px", padding: "8px 16px" }}>
                        {t("common.clear").toUpperCase()}
                      </Button>
                      <Button type="primary" htmlType="submit" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}>
                        {t("creatTamplete.Search").toUpperCase()}
                      </Button>
                    </Space>
                  </Row>
                </Card>
              )
              }
              <CompanyConfigMailTable
                isLoading={isLoading}
                pagination={pagination}
                configMailList={configMailList}
                onView={onView}
                onEdit={onEdit}
                onDelete={onDelete}
                onChange={onChange}
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default CompanyConfigMailFilter;
